import LoadingStore from './loading';
import MessageStore from './message'
import ModalStore from './modal';
import CloseDown from './CloseDown'
import ActiveStore from './Active'

export interface UIStoreTypes {
  LoadingStore: LoadingStore
  MessageStore: MessageStore
  ModalStore: ModalStore
  CloseDown: CloseDown
  ActiveStore: ActiveStore
}

const UIStore = {
  LoadingStore: new LoadingStore(),
  MessageStore: new MessageStore(),
  ModalStore: new ModalStore(),
  CloseDown: new CloseDown(),
  ActiveStore: new ActiveStore()
}

export default UIStore;
